import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import About from "@/sections/About";
import CaseStudies from "@/sections/CaseStudies";
import Pricing from "@/sections/Pricing";
import Testimonials from "@/sections/Testimonials";
import FAQ from "@/sections/FAQ";
import Blog from "@/sections/Blog";
import BookCall from "@/sections/BookCall";
import Footer from "@/sections/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);

    // If arriving from another page with a hash (e.g. /#services), scroll to it.
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target) {
        setTimeout(() => lenis.scrollTo(target, { offset: -70, immediate: false }), 400);
      }
    }

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-brand-cream text-brand-ink font-body antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <CaseStudies />
        <Pricing />
        <Testimonials />
        <Blog />
        <FAQ />
        <BookCall />
      </main>
      <Footer />
    </div>
  );
}
